import { shuffle } from '../../../utils/array-utils';
import type { TileColor } from '../../boardMVC/TileColor';
import type { LevelData } from '../LevelData';
import { TILE_COLORS } from '../../boardMVC/TileColor';
import { extractLevelColors } from './extractLevelColors';

export function extractLevelRefillColors(levelData: LevelData): TileColor[] {
  const colors = extractLevelColors(levelData);
  const unusedColors = shuffle(TILE_COLORS.filter((color) => !colors.includes(color)));
  return colors.concat(unusedColors);
}
